const formatFilters = (filters = {}) =>
    Object.keys(filters).map(key => {
        const value = filters[key]?.value || filters[key];
        const customValue = filters[key]?.customValue;
        return { name: key, value, customValue };
    });

const getSavedFilters = (availableFiltersList = [], listKey) => {
    const savedFilters = getFilterStorage(listKey) || {};
    return getOnlyAvailableFilters(availableFiltersList, savedFilters);
}

const getOnlyAvailableFilters = (availableFiltersList, savedFilters) =>
    Object.keys(savedFilters).reduce((acc, key) => {

        const savedFilter = savedFilters[key];
        const filterIsAvailable = availableFiltersList.some(filter => (filter.name || filter.key) === key);

        if (filterIsAvailable)
            acc[key] = savedFilter;

        return acc;
    }, {});

const getFilterStorage = (listKey) => {
    return JSON.parse(localStorage.getItem(`@gestto/${listKey}`))
}

const setFilterStorage = (listKey, filters) => {
    localStorage.setItem(`@gestto/${listKey}`, JSON.stringify(filters))
}

const formatAppliedFilters = (currentAppliedFilters = {}) =>
    Object.keys(currentAppliedFilters).reduce((acc, key) => {
        const filter = currentAppliedFilters[key];
        return { ...acc, [key]: filter.value };
    }, {});

export default {
    formatFilters,
    getSavedFilters,
    setFilterStorage,
    formatAppliedFilters
}